<template>
  <div>
    <section class="relative overflow-hidden py-0 bg-slate-50 pb-8 md:pb-12">
      <header class="relative isolate overflow-hidden bg-brand-900 text-white">
        <div class="absolute inset-0 bg-[radial-gradient(circle_at_15%_10%,rgba(251,191,36,.25),transparent_27%),radial-gradient(circle_at_90%_100%,rgba(93,122,168,.28),transparent_32%)]"></div>
        <div class="absolute inset-0 opacity-20 [background-image:linear-gradient(rgba(255,255,255,.16)_1px,transparent_1px),linear-gradient(90deg,rgba(255,255,255,.16)_1px,transparent_1px)] [background-size:32px_32px]"></div>
        <div class="relative mx-auto max-w-7xl px-4 py-12 sm:px-6 md:py-16 lg:px-8">
          <nav class="mb-6 flex items-center gap-2 text-xs font-medium text-white/65" aria-label="İçerik yolu">
            <a href="/" class="transition hover:text-white">{{ locale === 'tr' ? 'Ana Sayfa' : 'Home' }}</a>
            <font-awesome-icon icon="fa-solid fa-chevron-right" class="h-2.5 w-2.5" />
            <span class="text-white/90">{{ pageHeading }}</span>
          </nav>
          <div class="max-w-3xl">
            <p class="mb-3 text-[11px] font-extrabold uppercase tracking-[.22em] text-amber-300">İnanç Turizm</p>
            <h1 class="text-3xl font-black leading-tight tracking-tight text-white md:text-5xl">{{ pageHeading }}</h1>
            <p class="mt-4 max-w-2xl text-sm leading-7 text-white/75 md:text-base">{{ pageIntro }}</p>
          </div>
        </div>
      </header>
      <div class="relative z-10 mx-auto -mt-5 max-w-7xl px-3 sm:px-6 lg:px-8">
      <div class="w-full mx-0 mt-8 relative max-w-7xl mx-auto px-0 sm:px-6 lg:px-8">
        <!-- Tab Navigation -->
        <div class="w-full sticky top-0 z-20 border-b border-neutral-200 bg-white/95 backdrop-blur-sm md:relative md:border-b-0 md:bg-transparent md:backdrop-blur-none">
          <nav class="overflow-x-auto scrollbar-hide px-3 py-2.5 md:px-0 md:py-4">
            <div class="flex md:justify-center gap-2 min-w-max md:min-w-0 md:flex-wrap">
              <a :href="tabPath('aboutus')" @click.prevent="goTab('aboutus')"
                :class="tab == 'aboutus' ? 'bg-brand-800 text-white shadow-md shadow-brand-800/25' : 'bg-neutral-100 text-neutral-700 hover:bg-neutral-200'"
                class="flex items-center gap-2 rounded-full px-4 py-2.5 text-sm font-semibold whitespace-nowrap transition-all duration-200 active:scale-95 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-700 focus-visible:ring-offset-2">
                <font-awesome-icon icon="fa-solid fa-building" class="h-3.5 w-3.5" />
                {{ $t('Hakkımızda') }}
              </a>
              <a :href="tabPath('comment')" @click.prevent="goTab('comment')"
                :class="tab == 'comment' ? 'bg-brand-800 text-white shadow-md shadow-brand-800/25' : 'bg-neutral-100 text-neutral-700 hover:bg-neutral-200'"
                class="flex items-center gap-2 rounded-full px-4 py-2.5 text-sm font-semibold whitespace-nowrap transition-all duration-200 active:scale-95 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-700 focus-visible:ring-offset-2">
                <font-awesome-icon icon="fa-solid fa-comments" class="h-3.5 w-3.5" />
                {{ $t('Yorumlar') }}
              </a>
              <a :href="tabPath('photo')" @click.prevent="goTab('photo')"
                :class="tab == 'photo' ? 'bg-brand-800 text-white shadow-md shadow-brand-800/25' : 'bg-neutral-100 text-neutral-700 hover:bg-neutral-200'"
                class="flex items-center gap-2 rounded-full px-4 py-2.5 text-sm font-semibold whitespace-nowrap transition-all duration-200 active:scale-95 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-700 focus-visible:ring-offset-2">
                <font-awesome-icon icon="fa-solid fa-images" class="h-3.5 w-3.5" />
                {{ $t('Fotoğraflar') }}
              </a>
              <a :href="tabPath('document')" @click.prevent="goTab('document')"
                :class="tab == 'document' ? 'bg-brand-800 text-white shadow-md shadow-brand-800/25' : 'bg-neutral-100 text-neutral-700 hover:bg-neutral-200'"
                class="flex items-center gap-2 rounded-full px-4 py-2.5 text-sm font-semibold whitespace-nowrap transition-all duration-200 active:scale-95 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-700 focus-visible:ring-offset-2">
                <font-awesome-icon icon="fa-solid fa-file-invoice" class="h-3.5 w-3.5" />
                {{ $t('Belgeler') }}
              </a>
              <a :href="tabPath('team')" @click.prevent="goTab('team')"
                :class="tab == 'team' ? 'bg-brand-800 text-white shadow-md shadow-brand-800/25' : 'bg-neutral-100 text-neutral-700 hover:bg-neutral-200'"
                class="flex items-center gap-2 rounded-full px-4 py-2.5 text-sm font-semibold whitespace-nowrap transition-all duration-200 active:scale-95 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-700 focus-visible:ring-offset-2">
                <font-awesome-icon icon="fa-solid fa-users" class="h-3.5 w-3.5" />
                {{ $t('Ekibimiz') }}
              </a>
            </div>
          </nav>
        </div>
        <div class="mx-auto mt-4 max-w-7xl rounded-3xl border border-neutral-200 bg-white/90 px-3 py-5 shadow-xl shadow-brand-900/5 md:px-6 md:py-7">
        <!-- Testimonial grid list-->
        <template v-if="tab == 'aboutus'">
          <div class="grid gap-4 md:grid-cols-3">
            <article v-for="item in trustHighlights" :key="item.title" class="rounded-2xl border border-slate-200 bg-slate-50 p-5">
              <span class="inline-flex h-10 w-10 items-center justify-center rounded-xl bg-accent-100 text-accent-700"><font-awesome-icon :icon="item.icon" class="h-4 w-4" /></span>
              <h2 class="mb-1 mt-4 text-base font-bold text-slate-900">{{ item.title }}</h2>
              <p class="mb-0 text-sm leading-6 text-slate-600">{{ item.description }}</p>
            </article>
          </div>
          <div v-if="pageData && pageData.SA_Yazilar" class="prose prose-p:text-neutral-700 prose-headings:text-brand-900 mt-8 max-w-none text-base leading-7 md:text-lg"
            v-html="decodeHTMLEntities(pageData.SA_Yazilar, pageData)"></div>
        </template>
        <template v-if="tab == 'team'">
          <div class="teamp flex flex-col gap-4 py-3 text-md md:grid md:grid-cols-2">
            <span class="col-span-2">
            <h3 class="text-sm font-semibold uppercase tracking-wide text-accent-700">{{$t('TÜRKİYE EKİBİMİZ')}}</h3>
            </span>
            <div class="team-card flex flex-row gap-3">
              <div class="w-28 ">
                <img src="/assets/img/employee/MAHMUT.png"  alt="MAHMUT"  class="rounded-md h-24 w-24" />
              </div>
              <div class="grow leading-4">
                  <p class="my-3"><strong>MAHMUT ŞENADLI</strong></p>
                  <p class="my-3">POZISYON : <strong>GENEL MÜDÜR</strong></p>
                  <p class="my-3">E-mail : <strong>mahmut@inanctur.com.tr</strong></p>
                  <p class="my-3"><font-awesome-icon icon="fa-solid fa-mobile" class="h-3 w-3"></font-awesome-icon>: <strong>0532 510 32 45</strong></p>
                  <p class="my-3"><span>0850 241 41 41 Dahili: 1006</span></p>
                  <p class="my-3"><globalButton 
                    @click="modalContactForm()"
                    color="slate" size="sm" variant="primary" icon="fa-solid fa-envelope" iconClass="mr-2" :label="$t('Direkt Mesaj Gönder')"></globalButton></p>
              </div>
            </div> 
          
            <div class="team-card flex flex-row gap-3">
              <div class="w-28 ">
                <img src="/assets/img/employee/MURAT.png" alt="MURAT"  class="rounded-md h-24 w-24" />
              </div>
              <div class="grow leading-4">
                  <p class="my-3"><strong>MURAT ÇALIŞGAN</strong></p>
                  <p class="my-3">POZISYON : <strong>VİZE DEPARTMAN SORUMLUSU</strong></p>
                  <p class="my-3">E-mail : <strong>murat@inanctur.com.tr</strong></p>
                  <p class="my-3"><font-awesome-icon icon="fa-solid fa-mobile" class="h-3 w-3"></font-awesome-icon>: <strong>0533 293 03 52</strong></p>
                  <p class="my-3"><span>0850 241 41 41 Dahili: 1001</span></p>
              </div>
          </div> 

          <div class="team-card flex flex-row gap-3">
              <div class="w-28 ">
                <img src="/assets/img/employee/SULEYMAN.png" alt="Süleyman" class="rounded-md h-24 w-24" />
              </div>
              <div class="grow leading-4">
                  <p class="my-3"><strong>SÜLEYMAN KAPTI</strong></p>
                  <p class="my-3">POZISYON : <strong>MUHASEBE &FİNANS SORUMLUSU</strong></p>
                  <p class="my-3">E-mail : <strong>suleyman@inanctur.com.tr</strong></p>
                  <p class="my-3"><font-awesome-icon icon="fa-solid fa-mobile" class="h-3 w-3"></font-awesome-icon>: <strong>0544 440 31 99</strong></p>
                  <p class="my-3"><span>0850 241 41 41 Dahili: 1003</span></p>
              </div>  
          </div>  

          <div class="team-card flex flex-row gap-3">
            <div class="w-28 ">
              <img src="/assets/img/employee/NEJDET.png" alt="NEJDET"  class="rounded-md h-24 w-24" />
            </div>
            <div class="grow leading-4">
                <p class="my-3"> <strong>NEJDET GÜNEŞ</strong></p>
                <p class="my-3">POZISYON : <strong>SATIŞ & UÇUŞ PLANLAMA SORUMLUSU</strong></p>
                <p class="my-3">E-mail : <strong>nejdet@inanctur.com.tr</strong></p>
                <p class="my-3"><font-awesome-icon icon="fa-solid fa-mobile" class="h-3 w-3"></font-awesome-icon>: <strong>0543 440 31 93</strong></p>
                <p class="my-3"><span>0850 241 41 41 Dahili: 1000</span></p>
            </div>  
          </div>  

          <div class="team-card flex flex-row gap-3">
            <div class="w-28 ">
              <img src="/assets/img/employee/USER.png" alt="cem"  class="rounded-md h-24 w-24" />
            </div>
            <div class="grow leading-4">
              <p  class="my-3"><strong>CEM AVCI</strong></p>
              <p  class="my-3">POZISYON : <strong>HAC & UMRE GRUP PAZARLAMA</strong></p>
              <p  class="my-3">E-mail : <strong>cem@inanctur.com.tr</strong></p>
              <p  class="my-3"><font-awesome-icon icon="fa-solid fa-mobile" class="h-3 w-3"></font-awesome-icon>: <strong>0554 491 84 19</strong></p>
              <p  class="my-3"><span>0850 241 41 41 Dahili: 1007</span></p>
            </div> 
          </div> 

        
          <div class="team-card flex flex-row gap-3">
            <div class="w-28 ">
              <img src="/assets/img/employee/FURKAN.png" alt="Furkan" class="rounded-md h-24 w-24" />
            </div>
            <div class="grow leading-4">
              <p  class="my-3"><strong>FURKAN EREN GÜLÜM</strong></p>
              <p  class="my-3">POZISYON : <strong>HAC VE UMRE OPERASYON SORUMLUSU</strong></p>
              <p  class="my-3">E-mail : <strong>furkan@inanctur.com.tr</strong></p>
              <p  class="my-3"><font-awesome-icon icon="fa-solid fa-mobile" class="h-3 w-3"></font-awesome-icon>: <strong></strong></p>
              <p  class="my-3"><span>0850 241 41 41 Dahili: 1002</span></p>
            </div> 
          </div> 
 

          <div class="team-card flex flex-row gap-3">
            <div class="w-28 ">
              <img src="/assets/img/employee/USER.png" alt="fatih" class="rounded-md h-24 w-24" />
            </div>
            <div class="grow leading-4">
              <p class="my-3"><strong>FATİH DEMİR</strong></p>
              <p class="my-3">POZISYON : <strong>ARGE & İŞ GELİŞTİRME SORUMLUSU</strong></p>
              <p class="my-3">E-mail : <strong>fatih@inanctur.com.tr</strong></p>
              <p class="my-3"><font-awesome-icon icon="fa-solid fa-mobile" class="h-3 w-3"></font-awesome-icon>: <strong></strong></p>
              <p class="my-3"><span>0850 241 41 41 Dahili: 1006</span></p>
            </div> 
          </div> 

      
          <span class="col-span-2"><h3 class="mt-5 text-sm font-semibold uppercase tracking-wide text-accent-700">{{$t('SUUDİ ARABİSTAN EKİBİMİZ')}} </h3></span>
            
            <div class="team-brief"> 
              <p><strong>MAHMUT GÜLERYÜZ</strong></p>
              <p>POZISYON : <strong>Mekke Saha Hizmetleri</strong></p> 
            </div>
            <div class="team-brief"> 
              <p><strong>MEHMET KOÇ</strong></p>
              <p>POZISYON : <strong>Mekke Saha Hizmetleri</strong></p> 
            </div>
            <div class="team-brief"> 
              <p><strong>REZZUK KALEŞ</strong></p>
              <p>POZISYON : <strong>Medine Saha Hizmetleri</strong></p> 
            </div>
            <div class="team-brief"> 
              <p><strong>HARUN RECEP</strong></p>
              <p>POZISYON : <strong>Medine Saha Hizmetleri</strong></p> 
            </div>
            <section v-if="locale === 'tr'" class="col-span-2 mt-7 border-t border-slate-200 pt-7">
              <p class="mb-2 text-[11px] font-extrabold uppercase tracking-[.2em] text-accent-700">Manevi yolculuğunuzda yanınızda</p>
              <div class="flex flex-col justify-between gap-3 md:flex-row md:items-end">
                <div>
                  <h2 class="mb-0 text-2xl font-black text-brand-900 md:text-3xl">Rehberlerimiz</h2>
                  <p class="mb-0 mt-2 max-w-3xl text-sm leading-6 text-slate-600">İlahiyat, tarih, manevi rehberlik ve profesyonel turist rehberliği alanlarındaki birikimleriyle hac ve umre programlarımıza eşlik eden rehberlerimizi tanıyın.</p>
                </div>
                <span class="shrink-0 rounded-full bg-amber-50 px-3 py-1.5 text-xs font-bold text-amber-800">{{ guides.length }} rehber profili</span>
              </div>

              <div class="mt-6 grid gap-4 sm:grid-cols-2 xl:grid-cols-3">
                <a v-for="guide in guides" :key="guide.slug" :href="`/rehberler/${guide.slug}`" class="group flex min-h-[205px] flex-col overflow-hidden rounded-2xl border border-slate-200 bg-white p-5 shadow-sm transition hover:-translate-y-1 hover:border-amber-300 hover:shadow-lg">
                  <div class="flex items-center gap-4">
                    <img v-if="guide.image" :src="guide.image" :alt="`${guide.name} – İnanç Turizm rehberi`" class="h-16 w-16 rounded-2xl object-cover" width="64" height="64" loading="lazy" />
                    <span v-else class="inline-flex h-16 w-16 shrink-0 items-center justify-center rounded-2xl bg-brand-900 text-lg font-black text-amber-300" aria-hidden="true">{{ guideInitials(guide.name) }}</span>
                    <div>
                      <h3 class="mb-1 text-base font-black text-brand-900">{{ guide.name }}</h3>
                      <p class="mb-0 text-xs font-bold leading-5 text-accent-700">{{ guide.title }}</p>
                    </div>
                  </div>
                  <p class="mb-0 mt-4 text-xs leading-6 text-slate-600">{{ guide.shortDescription }}</p>
                  <span class="mt-auto pt-4 text-xs font-black text-brand-800">Profili incele <span aria-hidden="true" class="inline-block transition group-hover:translate-x-1">→</span></span>
                </a>
              </div>
            </section>
            
          </div>
        </template>
        <template v-else-if="tab == 'document'">
          <div class="mb-7 rounded-2xl border border-amber-200 bg-amber-50 p-4 text-sm leading-6 text-amber-950">
            <strong>{{ locale === 'tr' ? 'Belge doğrulama' : 'Document verification' }}</strong>
            <span class="ml-1">{{ locale === 'tr' ? 'En güncel belgelerimizi burada bulabilirsiniz.' : 'You can find our most up-to-date documents here.' }}</span>
          </div>
          <div class="grid gap-5 sm:grid-cols-2 xl:grid-cols-3">
            <figure v-for="document in documents" :key="document.title" class="group overflow-hidden rounded-2xl border border-slate-200 bg-white shadow-sm transition hover:-translate-y-1 hover:border-accent-300 hover:shadow-lg">
              <a :href="document.src" target="_blank" rel="noopener" class="block bg-slate-100" :aria-label="`${document.title}: ${locale === 'tr' ? 'büyük görüntüle' : 'view full size'}`">
                <img :src="document.src" :alt="document.alt" class="h-52 w-full object-cover object-top transition duration-500 group-hover:scale-[1.03]" :class="document.rotate ? 'rotate-90 scale-[1.45]' : ''" loading="lazy" />
              </a>
              <figcaption class="p-4">
                <div class="flex items-start justify-between gap-3">
                  <div>
                    <h2 class="mb-1 text-sm font-bold text-slate-900">{{ document.title }}</h2>
                    <p class="mb-0 text-xs leading-5 text-slate-600">{{ document.description }}</p>
                  </div>
                  <span class="shrink-0 rounded-full bg-slate-100 px-2 py-1 text-[10px] font-bold text-slate-500">{{ document.format }}</span>
                </div>
              </figcaption>
            </figure>
          </div>
          <section v-if="locale === 'tr'" class="mt-8 overflow-hidden rounded-3xl border border-slate-200 bg-slate-50">
            <div class="grid gap-0 lg:grid-cols-[1.1fr_.9fr]">
              <div class="p-5 md:p-7">
                <p class="mb-2 text-[10px] font-extrabold uppercase tracking-[.2em] text-accent-700">Doğrulanabilir kurum bilgileri</p>
                <h2 class="mb-0 text-2xl font-black text-brand-900">İnanç Turizm kurumsal bilgileri</h2>
                <p class="mb-0 mt-3 text-sm leading-6 text-slate-600">Belge ve iletişim bilgilerimizi rezervasyon öncesinde kontrol edebilir, resmî yetkili acente listesini doğrudan inceleyebilirsiniz.</p>

                <dl class="mt-6 grid gap-3 sm:grid-cols-2">
                  <div v-for="item in companyDetails" :key="item.label" class="rounded-xl border border-slate-200 bg-white p-4">
                    <dt class="text-[10px] font-extrabold uppercase tracking-wide text-slate-500">{{ item.label }}</dt>
                    <dd class="mb-0 mt-1 text-sm font-bold leading-6 text-slate-800">{{ item.value }}</dd>
                  </div>
                </dl>

                <a :href="diyanetAgencyListUrl" target="_blank" rel="noopener noreferrer" class="mt-5 inline-flex items-center rounded-xl bg-brand-900 px-4 py-3 text-sm font-black text-white transition hover:bg-brand-800">
                  Diyanet yetkili acente listesini doğrula <span class="ml-2" aria-hidden="true">↗</span>
                </a>
              </div>
              <div class="bg-brand-900 p-5 text-white md:p-7">
                <p class="mb-2 text-[10px] font-extrabold uppercase tracking-[.2em] text-amber-300">Merkez ofis</p>
                <h2 class="mb-0 text-xl font-black text-white">Bize ulaşın</h2>
                <address class="mt-5 not-italic text-sm leading-7 text-white/75">
                  Mahmutbey Mah. Taşocağı Yolu Cad. No:1<br />
                  Polat Tower &amp; Residence Kat 24 D:188<br />
                  Bağcılar / İstanbul
                </address>
                <div class="mt-5 space-y-2 text-sm font-bold">
                  <a href="tel:+908502414141" class="block text-white hover:text-amber-300">0850 241 41 41</a>
                  <a href="mailto:bilgi@inanctur.com.tr" class="block text-white hover:text-amber-300">bilgi@inanctur.com.tr</a>
                </div>
                <a :href="officeMapUrl" target="_blank" rel="noopener noreferrer" class="mt-6 block rounded-xl border border-white/20 bg-white/10 px-4 py-3 text-center text-sm font-bold text-white transition hover:bg-white/15">Haritada görüntüle ↗</a>
                <p class="mb-0 mt-5 border-t border-white/10 pt-4 text-[11px] leading-5 text-white/50">Kurum ve iletişim bilgileri son olarak 12 Eylül 2026 tarihinde gözden geçirilmiştir.</p>
              </div>
            </div>
          </section>
        </template>
         
        <template v-else-if="tab == 'photo'">
         
          <div>
            <template v-for="gallery in galleries" :key="gallery.pdb_Id || gallery.GalleryName?.[locale]">
              <section class="my-4 w-full rounded-2xl border border-neutral-200 bg-neutral-50/70 p-4">
                <h2 class="text-xl font-semibold text-brand-900 md:text-2xl" v-html="gallery.GalleryName?.[locale]"></h2>
                <div class="mt-3 flex w-full flex-wrap gap-2">
                  <button v-for="(img, index) in gallery.images" :key="`${img.i}-${index}`" type="button" class="h-28 flex-none overflow-hidden"
                    @click="openGalleryViewer(gallery.images, index)" :aria-label="`${gallery.GalleryName?.[locale] || 'Galeri'}: ${index + 1}`">
                    <img :src="showImage(img.i, 264, 180, true, 90)"
                      :alt="`${img.i} ${gallery.GalleryName?.[locale]}`"
                      class="h-24 rounded-xl border border-white object-cover shadow-sm transition duration-200 hover:-translate-y-0.5 hover:opacity-90 hover:ring-2 hover:ring-accent-500 hover:ring-offset-2 md:h-28" />
                  </button>
                </div>
              </section>
            </template>
          </div>
        </template>
        <template v-else-if="tab == 'comment'">
          <section class="overflow-hidden rounded-3xl bg-brand-900 p-5 text-white shadow-[0_22px_50px_-32px_rgba(22,32,51,.9)] md:p-7">
            <div class="flex flex-col justify-between gap-6 lg:flex-row lg:items-end">
              <div class="max-w-2xl">
                <div class="mb-3 inline-flex items-center gap-2 rounded-full border border-amber-300/30 bg-amber-300/10 px-3 py-1 text-[10px] font-extrabold uppercase tracking-[.18em] text-amber-200">
                  <font-awesome-icon icon="fa-solid fa-comments" class="h-3 w-3" />
                  {{ locale === 'tr' ? 'Doğrudan misafir deneyimleri' : 'Direct traveller experiences' }}
                </div>
                <h2 class="mb-0 text-2xl font-black text-white tracking-tight md:text-3xl">{{ locale === 'tr' ? 'Yolculuğu yaşayanlar anlatıyor' : 'Stories from travellers' }}</h2>
                <p class="mb-0 mt-3 text-sm leading-6 text-white/70">{{ locale === 'tr' ? 'Yorumları kaynak, tarih ve içerik üzerinden karşılaştırarak inceleyebilirsiniz.' : 'Compare reviews by source, date and content.' }}</p>
              </div>
              <div class="rounded-2xl border border-white/15 bg-white/10 px-4 py-3 backdrop-blur">
                <p class="mb-0 text-2xl font-black text-amber-300">{{ comments.length }}</p>
                <p class="mb-0 text-[11px] font-medium text-white/65">{{ locale === 'tr' ? 'yayınlanan yorum' : 'published reviews' }}</p>
              </div>
            </div>
          </section>

          <section class="mt-5 rounded-2xl border border-slate-200 bg-slate-50 p-3 md:p-4" aria-label="Yorum filtreleri">
            <div class="flex flex-col gap-3 lg:flex-row lg:items-center">
              <label class="relative block min-w-0 flex-1">
                <span class="sr-only">{{ locale === 'tr' ? 'Yorumlarda ara' : 'Search reviews' }}</span>
                <font-awesome-icon icon="fa-solid fa-magnifying-glass" class="pointer-events-none absolute left-3 top-1/2 h-3.5 w-3.5 -translate-y-1/2 text-slate-400" />
                <input v-model.trim="commentQuery" type="search" :placeholder="locale === 'tr' ? 'Yorumlarda ara' : 'Search reviews'" class="w-full rounded-xl border border-slate-200 bg-white py-2.5 pl-9 pr-3 text-sm text-slate-800 outline-none transition placeholder:text-slate-400 focus:border-accent-500 focus:ring-2 focus:ring-accent-100" />
              </label>
              <div class="flex flex-wrap gap-2" role="group" :aria-label="locale === 'tr' ? 'Kaynağa göre filtrele' : 'Filter by source'">
                <button v-for="source in commentSources" :key="source.value" type="button" @click="selectedCommentSource = source.value" class="rounded-full border px-3 py-2 text-xs font-bold transition" :class="selectedCommentSource === source.value ? 'border-brand-800 bg-brand-800 text-white shadow-sm' : 'border-slate-200 bg-white text-slate-600 hover:border-accent-300 hover:text-brand-800'">
                  {{ source.label }} <span class="ml-1 opacity-70">{{ source.count }}</span>
                </button>
              </div>
            </div>
            <p class="mb-0 mt-3 text-xs text-slate-500">{{ locale === 'tr' ? `${filteredComments.length} yorum listeleniyor.` : `${filteredComments.length} reviews are listed.` }}</p>
          </section>

          <div v-if="visibleComments.length" class="mt-5 grid gap-4 md:grid-cols-2">
            <div v-for="(column, columnIndex) in commentColumns" :key="`comment-column-${columnIndex}`" class="space-y-4">
              <article v-for="({ comment, index }) in column" :key="commentKey(comment, index)" class="group flex min-h-[220px] flex-col rounded-2xl border border-slate-200 bg-white p-5 shadow-[0_12px_28px_-24px_rgba(15,23,42,.55)] transition duration-200 hover:-translate-y-1 hover:border-accent-200 hover:shadow-lg">
              <div class="flex items-start justify-between gap-3">
                <span class="inline-flex h-9 w-9 items-center justify-center rounded-xl bg-amber-50 text-amber-600"><font-awesome-icon icon="fa-solid fa-quote-right" class="h-3.5 w-3.5" /></span>
                <div v-if="commentRating(comment)" class="flex items-center gap-0.5 text-amber-400" :aria-label="`${commentRating(comment)} / 5`">
                  <font-awesome-icon v-for="star in 5" :key="star" icon="fa-solid fa-star" class="h-3 w-3" :class="star <= commentRating(comment) ? '' : 'opacity-20'" />
                </div>
              </div>
              <p class="mb-5 mt-4 text-sm leading-6 text-slate-700">{{ plainComment(comment.yh_Message) }}</p>
              <footer class="mt-auto border-t border-slate-100 pt-4">
                <div class="flex items-center gap-3">
                  <span class="inline-flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-gradient-to-br from-brand-700 to-brand-900 text-sm font-black text-white">{{ String(comment.yh_Name || 'İ').charAt(0) }}</span>
                  <div class="min-w-0 flex-1">
                    <p class="mb-0 truncate text-sm font-bold text-slate-800">{{ [comment.yh_Name, comment.yh_Surname].filter(Boolean).join(' ') || (locale === 'tr' ? 'İnanç Tur misafiri' : 'Inanç Tur guest') }}</p>
                    <div class="mt-1 flex items-center justify-between gap-2 text-[11px] text-slate-500">
                      <a v-if="safeExternalUrl(comment.yh_Details)" :href="safeExternalUrl(comment.yh_Details)" target="_blank" rel="noopener nofollow" class="inline-flex items-center gap-1 font-semibold text-brand-700 hover:text-brand-900">
                        <font-awesome-icon :icon="sourceIcon(comment.yh_Source)" class="h-3 w-3" /> {{ sourceLabel(comment.yh_Source) }}
                        <font-awesome-icon icon="fa-solid fa-arrow-up-right-from-square" class="h-2.5 w-2.5" />
                      </a>
                      <span v-else class="inline-flex items-center gap-1"><font-awesome-icon :icon="sourceIcon(comment.yh_Source)" class="h-3 w-3" /> {{ sourceLabel(comment.yh_Source) }}</span>
                      <time v-if="comment.yh_CommentDate" :datetime="comment.yh_CommentDate" class="shrink-0">{{ formatDate(comment.yh_CommentDate, 'dd MMM yy') }}</time>
                    </div>
                  </div>
                </div>
              </footer>
              </article>
            </div>
          </div>
          <div v-else class="mt-5 rounded-2xl border border-dashed border-slate-300 bg-slate-50 px-5 py-12 text-center">
            <font-awesome-icon icon="fa-solid fa-magnifying-glass" class="h-5 w-5 text-slate-400" />
            <p class="mb-0 mt-3 text-sm font-semibold text-slate-700">{{ locale === 'tr' ? 'Bu filtrelerle eşleşen yorum bulunamadı.' : 'No reviews match these filters.' }}</p>
            <button type="button" class="mt-3 text-sm font-bold text-brand-700 hover:text-brand-900" @click="resetCommentFilters">{{ locale === 'tr' ? 'Filtreleri temizle' : 'Clear filters' }}</button>
          </div>
          <div v-if="visibleComments.length < filteredComments.length" class="mt-6 text-center">
            <button type="button" class="rounded-xl border border-accent-200 bg-accent-50 px-5 py-3 text-sm font-bold text-accent-800 transition hover:bg-accent-100" @click="commentsLimit += 12">
              {{ locale === 'tr' ? `Daha fazla yorum göster (${filteredComments.length - visibleComments.length})` : `Show more reviews (${filteredComments.length - visibleComments.length})` }}
            </button>
          </div>
        </template>
        </div>
        <div v-if="tab === 'comment'" class="mx-auto mt-8 max-w-3xl rounded-2xl border border-neutral-200 bg-neutral-50 px-5 py-5 text-sm leading-7 text-neutral-700">
          {{ locale === 'tr' ? 'Yorumlar, tur ve şirket seçiminizde yararlı bir referans olabilir. Yorumları güncelliği, kaynak bağlantısı ve tur programındaki otel, uçuş, transfer ve hizmet detaylarıyla birlikte değerlendirmenizi öneririz.' : 'Reviews can be a useful reference when choosing a tour or company. We recommend evaluating their recency and source alongside the hotel, flight, transfer and service details of the specific tour.' }}
        </div>
      </div>
      </div>
    </section>
    <TourLazyGalleryViewer
      v-if="showGallery" :selectedIndex="selectedIndex" :images="gallery"
      @close="closeViewer()"
      @setIndex="event=>selectedIndex=event"
    ></TourLazyGalleryViewer>
  </div>
</template>
<script setup>
import { ref, computed, watch } from 'vue';
import axios from "axios";
import 'vue3-carousel/dist/carousel.css' 
import { guides } from '~/data/guides'
 
const route = useRoute()
const link = computed(()=>{
  return route.params.link;
})
const { locale } = useI18n() 
const config = useRuntimeConfig();


const pageData = usePageData();
const contactForm = useContactForm();

const props = defineProps({
  inModal:{
    type: String,
    default: null
  }
})

const emit = defineEmits(['inModal'])

const { goPath, showImage, decodeHTMLEntities, formatDate } = useCommon();

const diyanetAgencyListUrl = 'https://hacumre.diyanet.gov.tr/Documents/2025-2026%20UMRE%20UMRE%20ORGANIZAYONU%20YETKILI%20ACENTELER%20LISTESI.25.09.2025.pdf'
const officeMapUrl = 'https://maps.google.com/maps/dir//%C4%B0nan%C3%A7+Turizm+Mahmutbey+Mah.+Ta%C5%9Foca%C4%9F%C4%B1+Yolu+Cad.+No:1+Polat+Tower%26Residance+kat+24+daire+188+Ba%C4%9Fc%C4%B1lar%2F%C4%B0stanbul/@41.0463828,28.8114007,15z/data=!4m5!4m4!1m0!1m2!1m1!1s0x14cab86f3f379145:0xa7939b402ce4764b'
const companyDetails = [
  { label: 'Marka', value: 'İnanç Turizm' },
  { label: 'Seyahat acentası', value: 'İnançtur Turizm' },
  { label: 'TÜRSAB belge no', value: '7677' },
  { label: 'Acenta sınıfı', value: 'A Grubu Seyahat Acentası' },
  { label: 'Telefon', value: '0850 241 41 41' },
  { label: 'E-posta', value: 'bilgi@inanctur.com.tr' }
]
const guideInitials = (name) => String(name || '').split(' ').map(part => part.charAt(0)).slice(0, 2).join('')

 
const gallery = ref(null)

const showGallery = ref(false)
const selectedIndex = ref(0);
const openGalleryViewer = (glry, index) => {
  console.log("glry",glry)
  gallery.value = glry
  selectedIndex.value = index;
  showGallery.value = true;
}
const closeViewer = ()=>{
  gallery.value = null
  selectedIndex.value = 0;
  showGallery.value = false;
}
const goTab = (tab)=>{
  let t = tab;
  let tabName = tab;
    if(t=="comment") tabName="yorumlar";
    else if(t=="document") tabName="belgeler";
    else if(t=="photo") tabName="umre-tur-fotograflari";
    else if(t=="video") tabName="videolar";
    else if(t=="team") tabName="ekibimiz";
    else if(t=="aboutus") tabName="hakkimizda";

 
  if(!props.inModal){
    goPath("/page/"+tabName)
  }else{
    tabName=tab;
    emit("settab",tab)
  }
 
}

const tabPath = (tab) => {
  if (props.inModal) return '#'
  const paths = {
    aboutus: 'hakkimizda',
    comment: 'yorumlar',
    photo: 'umre-tur-fotograflari',
    document: 'belgeler',
    team: 'ekibimiz'
  }
  return `/page/${paths[tab] || 'hakkimizda'}`
}

const tab = computed(()=>{
    if(props.inModal){
      return props.inModal;
    }else{ 
      let t = route.params.link;
      let tabName = route.params.link;
      if(t=="yorumlar" || t=="comments") tabName="comment";
      else if(t=="belgeler" || t=="documents") tabName="document";
      else if(t=="umre-tur-fotograflari" || t=="umrah-tour-photos") tabName="photo";
      else if(t=="videolar" || t=="videos") tabName="video";
      else if(t=="ekibimiz" || t=="our-team") tabName="team";
      else if(t=="hakkimizda" || t=="aboutus") tabName="aboutus";
      return tabName;
    }
})

const pageHeading = computed(() => ({
  aboutus: locale.value === 'tr' ? 'İnanç Turizm Hakkında' : 'About Inanç Turizm',
  comment: locale.value === 'tr' ? 'Misafir Yorumları' : 'Traveller Reviews',
  photo: locale.value === 'tr' ? 'Yolculuk Fotoğrafları' : 'Journey Photos',
  document: locale.value === 'tr' ? 'Yetki ve Üyelik Belgeleri' : 'Authorisation and Membership Documents',
  team: locale.value === 'tr' ? 'Ekibimiz' : 'Our Team'
}[tab.value] || (locale.value === 'tr' ? 'İnanç Turizm' : 'Inanç Turizm')))

const pageIntro = computed(() => ({
  aboutus: locale.value === 'tr' ? 'Hac, umre ve seyahat planlamasında hizmet yaklaşımımızı, ekibimizi ve doğrulanabilir kurum bilgilerimizi inceleyin.' : 'Explore our service approach, team and verifiable company information for Hajj, Umrah and travel planning.',
  comment: locale.value === 'tr' ? 'Misafirlerimizin deneyimlerini, yayınlandıkları kaynak ve tarih bilgileriyle birlikte inceleyin.' : 'Explore traveller experiences together with their publication source and date.',
  photo: locale.value === 'tr' ? 'Farklı gruplarımızın yolculuklarından paylaşılan fotoğrafları görüntüleyin.' : 'Browse photos shared from the journeys of our different groups.',
  document: locale.value === 'tr' ? 'Kurum ve yetki belgelerimizi, her belgenin neyi gösterdiğini açıklayan kartlarla inceleyin.' : 'Review our company and authorisation documents in cards that explain each document.',
  team: locale.value === 'tr' ? 'Türkiye ve Suudi Arabistan’daki ekiplerimizi ve uzmanlık alanlarını tanıyın.' : 'Meet our teams in Türkiye and Saudi Arabia and their areas of expertise.'
}[tab.value] || ''))

const trustHighlights = computed(() => locale.value === 'tr'
  ? [
      { icon: 'fa-solid fa-passport', title: 'Her şey net!', description: 'Tur kapsamını; uçuş, konaklama, transfer ve rehberlik ayrıntılarıyla en net şekilde sunarız.' },
      { icon: 'fa-solid fa-users', title: 'Rehber ve Saha Ekibi', description: 'Türkiye ve Suudi Arabistan ekiplerimiz yolculuk sürecindeki en iyi hizmeti vermeye odaklanır.' },
      { icon: 'fa-solid fa-file-invoice', title: 'Şeffaf bilgi', description: 'Program detayları, sözleşmeleri ve yetki belgeleri tek bir yerde erişilebilir olur.' }
    ]
  : [
      { icon: 'fa-solid fa-passport', title: 'Planned journeys', description: 'We help you review flights, accommodation, transfers and guidance details together.' },
      { icon: 'fa-solid fa-users', title: 'Local field support', description: 'Our teams in Türkiye and Saudi Arabia focus on coordination throughout the journey.' },
      { icon: 'fa-solid fa-file-invoice', title: 'Clear information', description: 'Authorisation documents, programme details and traveller experiences are available in one place.' }
    ])

const documents = computed(() => [
  { title: locale.value === 'tr' ? 'Hac Yetki Belgesi' : 'Hajj Authorisation Certificate', description: locale.value === 'tr' ? 'Hac organizasyonuna ilişkin yetki belgesi.' : 'Authorisation certificate related to Hajj organisation.', format: 'PNG', src: '/assets/img/belgeler/HAC-2026-2027.png', alt: 'İnanç Turizm hac yetki belgesi' },
  { title: locale.value === 'tr' ? 'Umre Yetki Belgesi' : 'Umrah Authorisation Certificate', description: locale.value === 'tr' ? 'Umre organizasyonuna ilişkin yetki belgesi.' : 'Authorisation certificate related to Umrah organisation.', format: 'PNG', src: '/assets/img/belgeler/umre-2026.png', alt: 'İnanç Turizm umre yetki belgesi' },
  { title: locale.value === 'tr' ? 'A Grubu Seyahat Acentası Belgesi' : 'Group A Travel Agency Certificate', description: locale.value === 'tr' ? 'Seyahat acentası işletme belgesi.' : 'Travel agency operating certificate.', format: 'JPG', src: '/assets/img/belgeler/A_GRUBU_ISLETME BELGESI_INANC_TURIZM.jpg', alt: 'İnanç Turizm A grubu seyahat acentası belgesi' },
  { title: locale.value === 'tr' ? 'Diyanet Yetki Belgesi' : 'Diyanet Authorisation Certificate', description: locale.value === 'tr' ? 'Diyanet yetkilendirmesine ilişkin belge.' : 'Document related to Diyanet authorisation.', format: 'WEBP', src: '/assets/img/belgeler/INANCTUR-2025-2026-UMRE-DIYANET-YETKI-BELGESI.webp', alt: 'İnanç Turizm Diyanet umre yetki belgesi' },
  { title: locale.value === 'tr' ? 'IATA Belgesi' : 'IATA Certificate', description: locale.value === 'tr' ? 'IATA ile ilgili kurumsal belge.' : 'Corporate document related to IATA.', format: 'JPG', src: '/assets/img/belgeler/IATA_inancturizm.jpg', alt: 'İnanç Turizm IATA belgesi', rotate: true },
  { title: locale.value === 'tr' ? 'TÜRSAB Üyelik Belgesi' : 'TÜRSAB Membership Certificate', description: locale.value === 'tr' ? 'TÜRSAB üyeliğine ilişkin belge.' : 'Document related to TÜRSAB membership.', format: 'WEBP', src: '/assets/img/belgeler/TURSAB_UYELIK_BELGESI.webp', alt: 'İnanç Turizm TÜRSAB üyelik belgesi' }
])

const plainComment = (value) => String(value || '')
  .replace(/<[^>]*>/g, ' ')
  .replace(/\s+/g, ' ')
  .trim()

const safeExternalUrl = (value) => {
  try {
    const url = new URL(String(value || ''))
    return ['http:', 'https:'].includes(url.protocol) ? url.href : ''
  } catch {
    return ''
  }
}

const galleries = ref([])
const comments = ref([])
const commentQuery = ref('')
const selectedCommentSource = ref('all')
const commentsLimit = ref(12)

const normaliseCommentSource = (source) => {
  const value = String(source || '').trim().toLowerCase()
  return ['google', 'facebook', 'instagram'].includes(value) ? value : 'website'
}

const sourceLabel = (source) => ({
  google: 'Google',
  facebook: 'Facebook',
  instagram: 'Instagram',
  website: locale.value === 'tr' ? 'Web sitesi' : 'Website'
}[normaliseCommentSource(source)])

const sourceIcon = (source) => ({
  google: 'fab fa-google',
  facebook: 'fab fa-facebook',
  instagram: 'fab fa-instagram',
  website: 'fa-solid fa-link'
}[normaliseCommentSource(source)])

const commentSources = computed(() => {
  const available = ['google', 'facebook', 'instagram', 'website']
    .map(value => ({
      value,
      label: sourceLabel(value),
      count: comments.value.filter(comment => normaliseCommentSource(comment.yh_Source) === value).length
    }))
    .filter(source => source.count)

  return [{
    value: 'all',
    label: locale.value === 'tr' ? 'Tümü' : 'All',
    count: comments.value.length
  }, ...available]
})

const filteredComments = computed(() => {
  const query = commentQuery.value.toLocaleLowerCase(locale.value === 'tr' ? 'tr-TR' : 'en-US')
  return comments.value.filter(comment => {
    const matchesSource = selectedCommentSource.value === 'all'
      || normaliseCommentSource(comment.yh_Source) === selectedCommentSource.value
    if (!matchesSource) return false
    if (!query) return true
    return [comment.yh_Name, comment.yh_Surname, comment.yh_Message, sourceLabel(comment.yh_Source)]
      .map(value => plainComment(value).toLocaleLowerCase(locale.value === 'tr' ? 'tr-TR' : 'en-US'))
      .some(value => value.includes(query))
  })
})

const visibleComments = computed(() => filteredComments.value.slice(0, commentsLimit.value))

const commentColumns = computed(() => {
  const columns = [[], []]
  const heights = [0, 0]

  visibleComments.value.forEach((comment, index) => {
    const targetColumn = heights[0] <= heights[1] ? 0 : 1
    columns[targetColumn].push({ comment, index })
    // Kart yüksekliğini yaklaşık olarak yorum metni üzerinden dengeler.
    heights[targetColumn] += plainComment(comment.yh_Message).length + 180
  })

  return columns
})

const commentRating = (comment) => {
  const rating = Number(comment?.yh_PointsAvg)
  return Number.isFinite(rating) && rating >= 1 && rating <= 5 ? Math.round(rating) : 0
}

const commentKey = (comment, index) => [
  comment?.yh_CommentDate || '',
  comment?.yh_Name || '',
  comment?.yh_Surname || '',
  plainComment(comment?.yh_Message).slice(0, 48),
  index
].join('-')

const resetCommentFilters = () => {
  commentQuery.value = ''
  selectedCommentSource.value = 'all'
}

watch([commentQuery, selectedCommentSource], () => {
  commentsLimit.value = 12
})

const getComments = (offset = 0) => {

  let limit = 100;
  // let order = 'random()';
  let order = 'yh_CommentDate DESC';

  const headers = useHeader()?.value 
     
            
  // axios({
  //     url: `${config.public.apiBase}`+"/rest/custom/getComments",
  //     method: "get",
  //     origin: true,
  //     withCredentials: true,
  //     headers,
  //     params: {
  //       limit: 100,
  //       offset:0,
  //     },
  // })
  //   .then(response => {
  //       console.log("comments",response)
  //   })
  //   .catch(e => {
  //     console.log("error:" + e);
  //   });

  axios({
    url: `${config.public.apiBase}`+"/graphql/direct",
    method: "post",
    data: {
      query:
        `
            {
                comments(  pdb_status:  1, order: "` +
        order +
        `", limit:` +
        limit +
        `, offset:` +
        offset +
        `){ 
                        yh_Name
                        yh_Surname
                        yh_Source
                        yh_Company
                        yh_job
                        yh_Icon
                        yh_PointsAvg
                        yh_Message 
                        yh_Details
                        yh_CommentDate
                }
            }
            `
    }
  })
    .then(response => {
      comments.value = Array.isArray(response?.data?.data?.comments) ? response.data.data.comments : [];
      commentsLimit.value = 12;
    })
    .catch(e => {
      console.log("error:" + e);
    });
}


const getGalleries = (offset = 0) => {

  let limit = 50;
  let order = 'pdb_sira DESC';
  // let order = 'yh_Pop DESC';

  axios({
    url: `${config.public.apiBase}`+"/graphql/direct",
    method: "post",
    data: {
      query:
        `
               {
                   galleries(  pdb_status:  1, order: "` +
        order +
        `", limit:` +
        limit +
        `, offset:` +
        offset +
        `){ 
                GalleryName{
                  tr,
                  en
                }, 
                GalleryPhoto
                   }
               }
               `
    }
  })
    .then(response => {

      galleries.value = response.data.data.galleries.map(item => {

        let images = [];
        if (item.GalleryPhoto && (item.GalleryPhoto.charAt(0) == "[" || item.GalleryPhoto.charAt(0) == "{")) {
          let gallery = JSON.parse(item.GalleryPhoto);
          if (Array.isArray(gallery)) {

          } else if (typeof gallery == "object") {

            gallery = Object.values(gallery)

          }
          if (gallery && gallery[0]) {
            gallery.forEach(img => {
              images.push({ i: 'https://image.inanctur.com.tr/yonetim/' + img.i, t: img.t, name: item.sOtelAdi?.tr })

            })
          }
        }
        return {
          images,
          ...item
        }

      })


    })
    .catch(e => {
      console.log("error:" + e);
    });
}

const modalContactForm = ()=>{
  contactForm.value.show = true;
}

const loadTabData = (t) => {
  if(t=="comment" && comments.value.length === 0){
    getComments(0);
  }else if(t=="photo" && galleries.value.length === 0){
    getGalleries(0);
  }
}

loadTabData(tab.value);

watch(tab, (newTab) => {
  loadTabData(newTab);
})

</script>

<style scoped>
.team-card {
  border: 1px solid #d9e1ea;
  border-radius: 1rem;
  background: #ffffff;
  padding: 1rem;
  box-shadow: 0 10px 24px rgba(22, 32, 51, 0.06);
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.team-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 14px 28px rgba(22, 32, 51, 0.1);
}

.team-brief {
  border: 1px solid #d9e1ea;
  border-radius: 0.85rem;
  background: #f8fafc;
  padding: 0.85rem;
  color: #334155;
}

.doc-img {
  width: 100%;
  max-width: 48rem;
  border-radius: 1rem;
  border: 1px solid #d9e1ea;
  background: #ffffff;
  padding: 0.35rem;
  box-shadow: 0 8px 24px rgba(22, 32, 51, 0.08);
}
</style>
